"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidEntityIssueType = exports.InvalidEntityResolution = exports.InvalidEntityType = void 0;
/**
 * Enum for the type of entity that is invalid.
 */
var InvalidEntityType;
(function (InvalidEntityType) {
    InvalidEntityType["ORDER"] = "ORDER";
    InvalidEntityType["ORDER_ITEM"] = "ORDER_ITEM";
    InvalidEntityType["SHIPMENT"] = "SHIPMENT";
})(InvalidEntityType || (exports.InvalidEntityType = InvalidEntityType = {}));
/**
 * Enum for the resolution status of an invalid entity.
 */
var InvalidEntityResolution;
(function (InvalidEntityResolution) {
    InvalidEntityResolution["MODIFIED"] = "MODIFIED";
    InvalidEntityResolution["REMOVED"] = "REMOVED";
    InvalidEntityResolution["CANCELLED"] = "CANCELLED";
})(InvalidEntityResolution || (exports.InvalidEntityResolution = InvalidEntityResolution = {}));
/**
 * Enum for the specific reason an entity is marked as invalid.
 */
var InvalidEntityIssueType;
(function (InvalidEntityIssueType) {
    // Order Level
    InvalidEntityIssueType["DUPLICATE_ORDER"] = "DUPLICATE_ORDER";
    InvalidEntityIssueType["INVALID_SHIP_BY"] = "INVALID_SHIP_BY";
    InvalidEntityIssueType["INVALID_ADDRESS"] = "INVALID_ADDRESS";
    // Item Level
    InvalidEntityIssueType["INSUFFICIENT_INVENTORY"] = "INSUFFICIENT_INVENTORY";
    InvalidEntityIssueType["PRODUCT_NOT_FOUND"] = "PRODUCT_NOT_FOUND";
    InvalidEntityIssueType["CASE_PACK_NOT_FOUND"] = "CASE_PACK_NOT_FOUND";
    // Shipment Level
    InvalidEntityIssueType["INVALID_TRANSPORTATION_DETAILS"] = "INVALID_TRANSPORTATION_DETAILS";
    // Generic / Fallback
    InvalidEntityIssueType["GENERIC_LINE_ITEM_RESOLUTION_ISSUE"] = "GENERIC_LINE_ITEM_RESOLUTION_ISSUE";
})(InvalidEntityIssueType || (exports.InvalidEntityIssueType = InvalidEntityIssueType = {}));
//# sourceMappingURL=InvalidEntityData.js.map